// extracted by mini-css-extract-plugin
export default {"map":"Distribution_map__azWGA","centroidNotice":"Distribution_centroidNotice__H13m-"};